module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "text",
      "data-uk-datepicker": _vm.options
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4653a8d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkDatepicker.vue
// module id = 289
// module chunks = 2